"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useBreakpoints;

var _reactResponsive = require("react-responsive");

var _theme = _interopRequireDefault(require("../../theme"));

function useBreakpoints() {
  var isMobile = (0, _reactResponsive.useMediaQuery)({
    query: "(max-width: ".concat(_theme["default"].breakpoints[0], ")")
  });
  var isTablet = (0, _reactResponsive.useMediaQuery)({
    query: "(max-width: ".concat(_theme["default"].breakpoints[1], ")")
  });
  var isDesktop = (0, _reactResponsive.useMediaQuery)({
    query: "(max-width: ".concat(_theme["default"].breakpoints[2], ")")
  });
  return {
    isMobile: isMobile,
    isTablet: isTablet,
    isDesktop: isDesktop
  };
}